import { GetTransportTypeModel } from "@factory/model/query-model-transport-type";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { transportTypeFormDefault } from "./form.default";
import { TransportTypeFormSchema } from "./form.rule";

export const useFormDefaultTransportType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTransportTypeModel | undefined) => {
    return !cachedValue
      ? transportTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as TransportTypeFormSchema);
  };

  return {
    getDefault,
  };
};
